// Auth
export const signInPath = () => '/sign-in'

// Companies
export const editCompanyPath = (id = ':id') => `/companies/${id}/edit`
export const companiesListPath = () => '/companies'
export const companyPath = (id = ':id') => `/companies/${id}`

// Employees
export const createEmployeePath = () => `/employees/create`
export const employeesListPath = () => '/employees'
export const employeePath = (id = ':id') => `/employees/${id}`

// Orders
export const ordersPath = () => '/orders'
export const orderPath = (id = ':id') => `/orders/${id}`

// Password
export const changePasswordPath = () => '/user/password/change'
export const resetPasswordPath = () => '/password/reset'
export const verifyPasswordPath = () => '/password/verify'

// Settings
export const settingsPath = () => '/settings'

// Transactions
export const transactionsPath = () => '/transactions'

// Invoices
export const invoicesPath = () => '/invoices'

export const defaultPath = companiesListPath
